module.exports = __webpack_public_path__ + "static/media/10.73baecd2.png";